import { BASE_URL, AUTH_HEADERS } from "./config"

export const getStatuses = async (update = null) => {
    const url = new URL(`${BASE_URL}/statuses`)
    if (update) {
        url.searchParams.append("update", 1)
    }
    const response = await fetch(url, {
        headers: AUTH_HEADERS
    })
    if (response.ok) {
        return await response.json()
    }
    return []
}

export const getStatus = async (statusId) => {
    const response = await fetch(`${BASE_URL}/statuses/${statusId}`, {
        headers: AUTH_HEADERS
    })
    if (response.ok) {
        return await response.json()
    }
    return {}
}

export const createStatus = async (status) => {
    const response = await fetch(`${BASE_URL}/statuses`, {
        method: "POST",
        headers: AUTH_HEADERS,
        body: JSON.stringify(status)
    })
    if (response.ok) {
        return await response.json()
    }
    return {}
}

export const updateStatus = async (statusId, status) => {
    const response = await fetch(`${BASE_URL}/statuses/${statusId}`, {
        method: "PATCH",
        headers: AUTH_HEADERS,
        body: JSON.stringify(status)
    })
    if (response.ok) {
        return await response.json()
    }
    return {}
}

export const deleteStatus = async (statusId) => {
    const response = await fetch(`${BASE_URL}/statuses/${statusId}`, {
        method: "DELETE",
        headers: AUTH_HEADERS
    })
    if (response.ok) {
        return await response.json()
    }
}